const initialState = {
  packsList: [],
};

export const packSizesReducer = (state = initialState, action) => {
  if (typeof action.execute === "function" && action.type === "pack-sizes")
    return action.execute(state);
  return state;
};
